import React, { useState, useCallback, useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import Root from './client_customizations/containers/Root/Root';
import { BrowserRouter as Router } from 'react-router-dom';
import { IntlProvider } from 'react-intl';
import * as serviceWorker from './serviceWorker';
import './utils/polyfills';
import MESSAGES from './context/translations/messages';
import {
  DEFAULT_LANGUAGE,
  LOCALE_CONFIG,
} from './context/translations/locales';
import './master.scss';

const resolveLanguage = (lang) =>
  lang && LOCALE_CONFIG[lang] ? lang : DEFAULT_LANGUAGE;

const App = () => {
  const [language, setLanguage] = useState(() =>
    resolveLanguage(localStorage.getItem('language'))
  );

  const changeLanguage = useCallback((lang) => {
    const nextLanguage = resolveLanguage(lang);
    localStorage.setItem('language', nextLanguage);
    setLanguage(nextLanguage);
  }, []);

  useEffect(() => {
    const locale = LOCALE_CONFIG[language] || LOCALE_CONFIG[DEFAULT_LANGUAGE];
    document.documentElement.lang = locale.htmlLang;
    document.documentElement.dir = locale.direction;
  }, [language]);

  const locale = LOCALE_CONFIG[language] || LOCALE_CONFIG[DEFAULT_LANGUAGE];
  const messages = MESSAGES[language] || MESSAGES[DEFAULT_LANGUAGE];

  return (
    <IntlProvider locale={locale.intlLocale} messages={messages}>
      <Router>
        <Root language={language} changeLanguage={changeLanguage} />
      </Router>
    </IntlProvider>
  );
};

const rootElement = document.getElementById('root');
const root = createRoot(rootElement);
root.render(<App />);

// ReactDOM.render(
//   <IntlProvider locale={language} messages={messages[language]}>
//     <Router>
//         <Root changeLanguage={changeLanguage}/>
//     </Router>
//   </IntlProvider>,
//   document.getElementById("root")
// );

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
